import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { QarepaBaseSubsDirective } from '@qarepa/common';
import { Account } from '@qaroni-app/account/types/account';
import { ProfileViewEnum } from '@qaroni-app/account/types/profile-view.enum';
import { ImagesConfig } from '@qaroni-core/conf/images/images.config';
import { AccountEditComponent } from '../account-edit/account-edit.component';
import { AccountInfoComponent } from '../account-info/account-info.component';
import { AccountResetPasswordComponent } from '../account-reset-password/account-reset-password.component';

@Component({
  selector: 'qaroni-account-profile',
  standalone: true,
  imports: [
    AccountEditComponent,
    AccountInfoComponent,
    AccountResetPasswordComponent,
    MatDialogModule,
    MatIconModule,
  ],
  templateUrl: './account-profile.component.html',
  styleUrl: './account-profile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountProfileComponent extends QarepaBaseSubsDirective {
  @Input() account: Account | null = null;
  @Output() closeProfile = new EventEmitter<boolean>();

  public ProfileViewEnum = ProfileViewEnum;
  public view = ProfileViewEnum.INFO;
  public ImagesConfig = ImagesConfig;

  public changeView(view: ProfileViewEnum): void {
    this.view = view;
  }

  public close(): void {
    this.closeProfile.emit(false);
    this.view = ProfileViewEnum.INFO;
  }
}
